import { isNil, isNotNil } from "@etudescarre/utils";
import { toaster } from "@/app";
import { apiClient } from "@/lib/api/client";

const OBJECT_URL_LIFETIME_MS = 60_000;

/** Opens a bordereau in a new tab: the exemplaire of one recipient, or all. */
export async function openBordereauPdf(
  yardId: string,
  slipId: number,
  recipientTeamId?: number,
) {
  try {
    const { data, error } = await apiClient.GET(
      "/api/yards/{yardId}/slips/{slipId}/bordereau-pdf",
      {
        params: {
          path: { yardId, slipId },
          query: isNotNil(recipientTeamId) ? { recipientTeamId } : {},
        },
        parseAs: "blob",
      },
    );
    if (isNotNil(data) && isNil(error)) {
      const url = URL.createObjectURL(data);
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), OBJECT_URL_LIFETIME_MS);
      return;
    }
  } catch (error) {
    console.error("Failed to open bordereau PDF", error);
  }
  toaster.error({
    title: "Bordereau non ouvert",
    description: "Le PDF du bordereau n'a pas pu être généré. Réessayez.",
  });
}

/** Opens a stored file (a report PDF…) in a new tab. */
export async function openFichier(yardId: string, fichierId: number) {
  const { data } = await apiClient.GET(
    "/api/yards/{yardId}/fichiers/{fichierId}/url",
    { params: { path: { yardId, fichierId: String(fichierId) } } },
  );
  if (isNotNil(data)) {
    window.open(data.data.inlineUrl, "_blank");
    return;
  }
  toaster.error({
    title: "Fichier non ouvert",
    description: "Ce fichier n'est pas accessible avec votre compte.",
  });
}
